<div class="tab-inner-content">
  <h2>Profit & Loss</h2>
  <h5>
    From {{ startDate | date : "MM/d/YYYY" }} to
    {{ endDate | date : "MM/d/YYYY" }}
  </h5>
  <div class="profit-loss-totals">
    <p>
      Net Profit :
      <span>AED {{ profitLossData?.netProfit | number : "1.2-2" }}</span>
    </p>
  </div>
  <table>
    <thead>
      <tr>
        <p class="balance-sheet-label-title">Income</p>
      </tr>
      <tr>
        <th>Account Name</th>
        <th>Total Debit (In AED)</th>
        <th>Total Credit (In AED)</th>
        <th>Net Amount (In AED)</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let node of profitLossData?.income">
        <td>{{ node.accountName }}</td>
        <td>{{ node.totalDebit | number : "1.2-2" }}</td>
        <td>{{ node.totalCredit | number : "1.2-2" }}</td>
        <td>{{ node.netAmount | number : "1.2-2" }}</td>
      </tr>
      <tr class="title" *ngIf="profitLossData?.income?.length !== 0">
        <td>Total Income</td>
        <td></td>
        <td></td>
        <td>AED {{ profitLossData?.totalIncome | number : "1.2-2" }}</td>
      </tr>
      <tr *ngIf="profitLossData?.income?.length === 0">
        <td colspan="4" class="no-data">No data available</td>
      </tr>
    </tbody>
  </table>
  <div style="padding: 12px 0px"></div>
  <table>
    <thead>
      <tr>
        <p class="balance-sheet-label-title">Expense</p>
      </tr>
      <tr>
        <th>Account Name</th>
        <th>Total Debit (In AED)</th>
        <th>Total Credit (In AED)</th>
        <th>Net Amount (In AED)</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let node of profitLossData?.expense">
        <td>{{ node.accountName }}</td>
        <td>{{ node.totalDebit | number : "1.2-2" }}</td>
        <td>{{ node.totalCredit | number : "1.2-2" }}</td>
        <td>{{ node.netAmount | number : "1.2-2" }}</td>
      </tr>
      <tr class="title" *ngIf="profitLossData?.expense?.length !== 0">
        <td>Total Expense</td>
        <td></td>
        <td></td>
        <td>AED {{ profitLossData?.totalExpense | number : "1.2-2" }}</td>
      </tr>
      <tr *ngIf="profitLossData?.expense?.length === 0">
        <td colspan="4" class="no-data">No data available</td>
      </tr>
    </tbody>
  </table>
</div>
